import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppContainer, PhoneAuth as PhoneAuthFlow } from './components';
import { setAxiosBaseUrl } from './api';
import { useSetTokensWithRedirect } from './hooks/useSetTokensWithRedirect';

export const PhoneAuth = ({
    baseURL,
    onSuccess,
    heading,
    body,
}: {
    baseURL: string;
    onSuccess?: (tokens?: any) => void;
    heading?: string;
    body?: string;
}) => {
    useEffect(() => {
        setAxiosBaseUrl(baseURL);
    }, []);

    const setTokensWithRedirect = useSetTokensWithRedirect(onSuccess);

    return (
        <Routes>
            <Route path="/" element={<AppContainer />}>
                <Route
                    path="/"
                    element={
                        <PhoneAuthFlow
                            setTokens={setTokensWithRedirect}
                            heading={heading}
                            body={body}
                        />
                    }
                />
            </Route>
        </Routes>
    );
};

export { accessToken, refreshToken } from './utils/auth';
export {
    setAxiosBaseUrl,
    setAxiosInterceptors,
    logout,
    invalidateToken,
    phone,
    passwordCreateOrResetAuthed,
    signUpWithEmailAndPassword,
    requestInitialEmailVerification,
    EmailVerificationRequestResponse,
    updateUserEmail,
    getUserProfile,
} from './api';
export type { SignUpUtmMeta, ExperimentMeta } from './api';
export { useSetTokensWithRedirect } from './hooks/useSetTokensWithRedirect';
export {
    ProtectedRoute,
    ClearAccounts,
    useAccountContext,
    AccountProvider,
    DirectOTPAuth,
    DirectOTPContainer,
    ResetPassword,
    ResetPasswordComponent,
    EmailResetInstructions,
    EmailOrPhoneAuth,
    AppContainer as AuthContainer,
    useAppContainerContext as useAuth,
    MagicLinkController,
    PhoneVerifyFlow,
    InvitationRoutes,
    ProductInvitationRoutes,
    CreatePasswordView,
    SubmittedStatusView,
} from './components';
export type { PasswordFormValues, ResetPasswordSubmitHandler } from './components';
